import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const ProvinceRoutes: RouteRecordRaw = {
  path: '/province',
  name: 'ProvinceModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageProvinceRoute',
      component: () => import('./views/ManageProvinceView.vue'),
      meta: {
        title: 'استان ها',
      },
    },
    {
      path: ':provinceId/city',
      name: 'ManageCityRoute',
      component: () => import('./views/ManageCityView.vue'),
      meta: {
        title: 'شهرها',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.province,
  },
}

export default (router: Router) => {
  router.addRoute(ProvinceRoutes)
}
